// src/pages/ChatPage.jsx - ИСПРАВЛЕННАЯ ВЕРСИЯ
import React, { useEffect, useState } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import ChatSidebar from '../components/chat/ChatSidebar';
import ChatWindow from '../components/chat/ChatWindow';
import ChatSearch from '../components/chat/ChatSearch';
import { useChat } from '../contexts/ChatContext';

const ChatPage = () => {
  const [searchParams] = useSearchParams();
  const { rooms, selectRoom, loadingRooms, currentRoom, resetCurrentRoom } = useChat();
  const [isInitialized, setIsInitialized] = useState(false);

  // ✅ СБРАСЫВАЕМ ВЫБОР ПРИ МОНТИРОВАНИИ СТРАНИЦЫ
  useEffect(() => {
    console.log('🔄 ChatPage mounted, resetting current room');
    resetCurrentRoom();
    setIsInitialized(false);
  }, [resetCurrentRoom]);

  // Автоматический выбор комнаты из URL параметров при первой загрузке
  useEffect(() => {
    const roomId = searchParams.get('roomId');
    if (roomId && rooms.length > 0 && !isInitialized) {
      const room = rooms.find(r => r.id === parseInt(roomId));
      if (room) {
        console.log('🔗 Auto-selecting room from URL:', roomId);
        selectRoom(room);
        setIsInitialized(true);
      }
    }
  }, [searchParams, rooms, selectRoom, isInitialized]);

  const handleSearchResult = (message) => {
    if (message.room_id) {
      const room = rooms.find(r => r.id === message.room_id);
      if (room) {
        selectRoom(room);
        // Скролл к найденному сообщению
        setTimeout(() => {
          const element = document.getElementById(`message-${message.id}`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.classList.add('highlight-message');
            setTimeout(() => element.classList.remove('highlight-message'), 2000);
          }
        }, 500);
      }
    }
  };

  if (loadingRooms) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Загрузка чатов...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="mb-3"></div>
      
      <Row className="g-0" style={{ 
        height: 'calc(100vh - 220px)',
        minHeight: '500px',
        backgroundColor: '#fff',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        <Col md={4} lg={3} className="border-end d-flex flex-column" style={{ height: '100%', overflow: 'hidden' }}>
          <div className="p-3 border-bottom bg-light">
            <h6 className="mb-3">
              <i className="bi bi-chat-dots me-2"></i>
              Чаты
            </h6>
            <ChatSearch 
              roomId={currentRoom?.id} 
              onResultClick={handleSearchResult}
            />
          </div>
          <div style={{ flex: 1, overflow: 'hidden' }}>
            <ChatSidebar onSelectRoom={selectRoom} />
          </div>
        </Col>
        <Col md={8} lg={9} style={{ height: '100%', overflow: 'hidden' }}>
          <ChatWindow />
        </Col>
      </Row>
    </>
  );
};

export default ChatPage;